export default __webpack_public_path__ + "static/media/staff5.295b858a.jpg";